<template>
	<aside>
		<header class="margin-bottom-15">
			<vButton v-if="transferStatus ===10||transferStatus===20" class="margin-right-15" theme="success" @click="retryAttach">{{$t('erp.distribution.pushfile',{ defaultValue: '附件重推' })}}</vButton>
			<vButton v-if="isShow"
				theme="primary"
				@click="showAttach=true"
				class="margin-right-15"
			>{{$t('fbb.alloment.add_attachment', { defaultValue: '添加附件' })}}</vButton>
			<vButton v-if="isShow" theme="gray" @click="clearAll">{{$tc('global.common.clear',1, { defaultValue: '清空所有' })}}</vButton>
		</header>
		<vTableSimple :columns="columns" :data="dataList"></vTableSimple>
		<compModal
                    v-model="modalProps.show"
                    v-bind="modalProps"
                    @on-close="modalProps.show=false"
                >
                    <component
                        v-if="modalProps.component"
                        :is="modalProps.component"
                        v-bind="modalProps.props"
                        v-on="modalProps.on"
                    />
                </compModal>
		<vModal

			v-model="showAttach"
			:title="$t('fbb.alloment.import_data', { defaultValue: '导入数据' })"
			width="520"
			:showFooter="false"
		>
			<vFormItem :label="$t('global.common.attachment_type', { defaultValue: '附件类型' })" inline labelWidth="auto" class="margin-bottom-5">
				<vSelect v-model="fileType">
					<vOption value="shiplabel">ShippingLabel</vOption>
					<vOption value="packlist">PackingList</vOption>
					<vOption value="bol">BOL</vOption>
                    <vOption value="cartonlabel">CartonLabel</vOption>
                    <vOption value="palletlabel">PalletLabel</vOption>
                    <vOption value="itemlabel">ItemLabel</vOption>
					<vOption value="Other"></vOption>
				</vSelect>
			</vFormItem>
			<footer class="margin-bottom-10">{{$t('fbb.inbound.support_formats', { defaultValue: 'ShippingLabel、PackingList、BOL三种类型支持格式为：PNG、JPG、PDF；Other格式不限' })}}</footer>

			<compMutiUpload v-bind="getFileProps" @on-cancel="showAttach=false" @on-success="handleAttach"/>
		</vModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</aside>
</template>

<script>
import { HttpDelAttach, HttpRetryAttach,/* HttpSubManageBillList, */HttpUploadAttach } from '@/service/allotment';
export default {
	props: ['data','status','checkManage'],
	components: {
		compUpload: () => import("@components/templates/upload"),
		compMutiUpload: () => import("@components/templates/mutiUpload")
	},
/* 	created() {
		console.log(this.status)
		if(this.isManageBill){
			HttpSubManageBillList({
				"search[EQ_id]":this.id
			}).then(res => {
				console.log(res)
				this.id = res.data.content[0].headId
			})
		}

  }, */
	data() {
		return {
			showAttach: false,
			fileType: 'Other',
			loading: false,
			type: this.$route.params.type,
			id: this.$route.query.id || '',
			dataList: this.data || [],
			attachList: [],
			attachMeta:{},
			attachMetas:[],
			Manage:this.checkManage,
			transferStatus:this.status|| '',
				modalProps: {
				show: false,
				component: "",
				width: 600,
				props: {},
				on: {},
			}
		}
	},
	watch: {
		data(val) {
			this.dataList = val;
		},
		status(val){
			this.transferStatus = val;
		},
		checkManage(val){
			this.Manage = val;
		},

	},
	computed: {
		isManageBill() {
			return this.$route.name === 'allotUpdateManage'
		},
		isShow(){
			return this.transferStatus ===''||this.transferStatus ===0||this.transferStatus===3||this.transferStatus===5||this.transferStatus===6||this.transferStatus===7||this.transferStatus===8||this.transferStatus===10||this.transferStatus===20||this.transferStatus===25
		},
		getFileProps() {
			return {
				/* action: process.env.VUE_APP_APIURL_FBB  + '/api/v2/TransferOutboundPlan/uploadAttachment',
				name: "multipartFile",
				data: {
					attachType: this.fileType,
					transferOutboundPlanId: this.id,
					isManageBill:this.Manage ,
				}, */
				action: process.env.VUE_APP_APIURL_UC + "/api/v1/BizAttach/uploadFile",
					name: "multipartFile",
					data: {
						srcLabel: this.id,
						model: "transfer",
						type: this.fileType
					},
				accept: this.fileType === 'Other' ? '' : 'image/*,application/pdf'
			}
		},
		columns() {
			return [{
				title: this.$t('global.common.attachment_type', { defaultValue: "附件类型" }),
				key: "attachType",
				// width:70
			},
            {
				title: this.$t('global.common.attachment_name', { defaultValue: "附件名称" }),
				key: "filename",
                render: (h, { row }) => {
					return <span class="color-link" onClick={this.handleWebfs.bind(this, row.fileurl, {}, 'download')}>{row.filename}</span>
				}
			},
            // {
			// 	title: this.$t('global.common.attachment_url', { defaultValue: "附件链接" }),
			// 	key: "fileurl",
			// 	width:400,
			// 	render: (h, { row }) => {
			// 		return <span class="color-link" onClick={this.handleWebfs.bind(this, row.fileurl, {}, 'download')}>{row.fileurl}</span>
			// 	}
			// 	// width: this.isManageBill ? undefined : 0
			// },
            {
				title: this.$t('global.common.createdtime', { defaultValue: "创建时间" }),
				width:130,
				key: "createdAt",
			}, {
				title: this.$t('global.common.operation', { defaultValue: "操作" }),
				width: !this.isShow ? 0 : 120,
				align: "center",
				render: (h, { row, index }) => {
					return <vButton theme="error" nativeOnClick={this.remove.bind(this, index)}>{this.$t('global.common.delete', { defaultValue: '删除' })}</vButton>
				}
			}]
		},
	},
	methods: {
		handleAttach(res) {
			// console.log("logloglog")
			this.attachMetas = [],
		   res.originData.forEach(item => {
				this.attachMeta = {};
				this.attachMeta.attachId = item.entity.id;
				this.attachMeta.filename = item.entity.filename;
				this.attachMeta.fileurl = item.entity.url;
				this.attachMeta.createdAt = item.entity.createdAt;
				this.attachMetas.push(this.attachMeta);
				/* this.attachMetas.push(this.attachMeta); */
			});
			HttpUploadAttach({
					attachType: this.fileType,
					transferOutboundPlanId: this.id,
					isManageBill:this.Manage ,
					listJSON:JSON.stringify(this.attachMetas)
			  }).then(res => {
				//   console.log(res.data)
				  res.data.forEach(item =>{
					this.dataList.push(item);
				  })

				// console.log(this.dataList)
				this.showAttach = false;
			}).catch(err => {
				this.$VMessage.error(err.message);
				this.loading = false;
			})
			// const data = res.data;
			/* this.dataList.push(this.attachMetas); */
		/* 	console.log(this.attachList)
			this.showAttach = false; */
		},

		clearAll() {
			this.modalProps={
                    show: true,//显示弹框
                    width:400, //弹框宽度
				    alert: 'success',//简洁模式主题和component模式互斥，
                    params: { transferOutboundPlanId: this.id, isManageBill:this.Manage,attachmentIds: this.dataList.map(item => item.id).join(',')},//接口参数
                    ajaxRequest: HttpDelAttach,//接口
                    desc: this.$t('fbb.alloment.confirm_clear_all', { defaultValue: '是否确认清空所有附件？？' }),
                    //不显示描述，
                    title: this.$t('global.common.clear', { defaultValue: '清空' }),//标题，
                    callback: ()=>{
						this.dataList = [];
					},//成功回调函数,
                };
			/* this.loading = true;
			HttpDelAttach({
				transferOutboundPlanId: this.id,
				isManageBill:this.Manage,
				attachmentIds: this.dataList.map(item => item.id).join(',')
			}).then(res => {
				this.loading = false;
				this.dataList = [];
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			}) */
		},
		remove(index) {
			this.loading = true;
			HttpDelAttach({
				transferOutboundPlanId: this.id,
				isManageBill:this.Manage,
				attachmentIds: this.dataList[index].id
			}).then(res => {
				this.loading = false;
				this.dataList.splice(index, 1);
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})

		},
		//页面:附件重推
		retryAttach() {
			this.loading = true;
			HttpRetryAttach({ transferOutboundPlanId: this.id ,isManageBill:this.Manage  }).then(res => {
				this.loading = false;
				this.$VMessage.success(res.message);
			}).catch(err => {
				this.$VMessage.error(err.message);
				this.loading = false;
			})
		}
	}
}
</script>
